import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { v4 as uuid4 } from 'uuid';
import { ConfigConstants } from '../../config/config-constants';

@Injectable()
export class HttpUtilitiesService {
    public setHeadersForIdempotency(headers: HttpHeaders): HttpHeaders {
        return headers
            .set('RequestID', uuid4().toString().replace(/-/g, '')) // GW does not want hyphens in the GUID
            .set('RepeatabilityCreation', moment().format(ConfigConstants.formatGatewayIdempotentHeaderDate));
    }
}
